import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import { FcHighPriority } from 'react-icons/fc';

const FailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const orderId = params.get('orderId');

  return (
    <div className="flex items-center flex-col justify-center min-h-screen bg-white">
      <div className="mt-[50px]">
        <NavLink to="/">
          <img
            src={`${process.env.PUBLIC_URL}/logo/logo.png`}
            alt="Creator Store"
            className="h-auto object-cover"
          />
        </NavLink>
      </div>
      <FcHighPriority className="text-6xl mt-[50px] mb-[20px]" />
      <h1 className="font-semibold text-[#333333] text-2xl text-center mb-4">
        주문 결제가
        <br />
        정상 처리되지 않았습니다.
      </h1>
      <p className="text-[#333333] text-sm mt-2">
        주문 번호: <strong>{orderId}</strong>
      </p>
      <ul className="mt-6">
        <li className="list-disc text-[#555555] text-sm font-medium">
          지속적으로 결제가 이루어지지 않는 경우{' '}
          <NavLink
            to="https://discord.com/invite/SbSCD7NXSY"
            className="text-[#5865f2] font-bold hover:underline"
          >
            디스코드
          </NavLink>
          로 문의 주세요.
        </li>
      </ul>
      <button
        type="button"
        className="mt-[50px] max-w-[400px] w-full bg-MainColor shadow-md rounded-full h-[50px] text-white transition duration-300 ease-in-out text-lg"
      >
        확인
      </button>
    </div>
  );
};

export default FailPage;
